// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"84":"0a34cd9a","386":"43159646","833":"e10b6f53","873":"0aa6192f","970":"df34d60a"}[chunkId] + ".css";
};